import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
          <img src="../img/logo.png" alt="logo" className="logo-img" />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#team" className="page-scroll">
                熱門遊戲
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                超級ＶＩＰ
              </a>
            </li>
            <li>
              <a href="#features" className="page-scroll">
                儲值優惠
              </a>
            </li>
            <li>
              <a href="https://w2.yhd.tw/shortcut/" className="page-scroll" target="blank">
                建立捷徑
              </a>
            </li>
            {/* <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li> */}
            {/* <li>
              <a href="#portfolio" className="page-scroll">
                portfolio
              </a>
            </li> */}
            {/* <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};
